import React from 'react';
import getValue from 'components/connectedForm/utils/getValue';
import FilterBase from './FilterBase';
import styles from 'styles/partials/_filterstring.css';
import Dropdown from 'components/connectedForm/Dropdown';
import fieldMetaData from 'graphql/schema/fieldMetaData';
import { BlurTextField } from '../connectedForm/inputComponents';
import { BlurTextFieldType } from '../connectedForm/BlurTextField/BlurTextField';
import { FilterStringType } from '../../graphql/schema/p4types';

export default class FilterString extends FilterBase {
  constructor(props) {
    super(props);

    this.getDescription = this.getDescription.bind(this);
    this.getQueryFilters = this.getQueryFilters.bind(this);
    this.renderPopout = this.renderPopout.bind(this);
  }

  getInitialValues(props) {
    const initialValues = Object.assign({}, props);
    if (!props.filterType) {
      initialValues.filterType = 'CONTAINS';
    }

    delete initialValues.label;
    delete initialValues.type;
    delete initialValues.fieldName;
    delete initialValues.onFilterUpdated;
    delete initialValues.position;
    delete initialValues.dispatch;
    delete initialValues.list;
    delete initialValues.initiallyOpen;

    return initialValues;
  }

  getDescription() {
    return this.getStandardDescription(['containsText']);
  }

  getQueryFilters() {
    return [
      {
        fieldName: this.props.fieldName,
        operation: 'LIKE',
        value: this.state.filterValues.containsText,
      },
    ];
  }

  handleChange(field, event) {
    const value = getValue(event);
    const filterValues = Object.assign({}, this.state.filterValues, {
      [field]: value,
    });
    this.setState({ filterValues: filterValues });
  }

  renderPopout() {
    const { filterType } = this.state.filterValues ?? {};

    return (
      <div className={styles.container}>
        <Dropdown
          autoFocus={true}
          id="filterType"
          setInputRef={this.setInputRef}
          label="Type"
          onChange={(value) => this.handleChange('filterType', value)}
          enum={true}
          options={fieldMetaData.FilterStringType.enumValues}
          value={this.state.filterValues.filterType}
          menuContainerStyle={{ maxWidth: '160px' }}
        />
        <BlurTextField
          id="containsText"
          className={styles.textfield}
          label="Text"
          value={this.state.filterValues.containsText}
          onChange={(value) => this.handleChange('containsText', value)}
          enableOnChange={true}
          testId={this.props.testid}
          type={filterType === FilterStringType.In ? BlurTextFieldType.TextArea : undefined}
          clearable={filterType === FilterStringType.In ? true : undefined}
          hint={
            filterType === FilterStringType.In ? (
              <div>
                Enter values seperated by a comma, space or new-lines. Any (exact) matches will be included in the
                results.
                <br />
                <br />
                {'E.g. "Apple, Banana, Cherry"'}
              </div>
            ) : undefined
          }
        />
      </div>
    );
  }
}
